import { FC } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Form, Input } from 'antd';
import classes from './index.module.less';
interface CaptchaInputInterface {
  name: string;
  sitekey: string;
}
const CaptchaInput: FC<CaptchaInputInterface> = ({
  name,
  sitekey
}) => {
  return <>
			<Form.Item name={name} noStyle rules={[{
      required: true,
      message: 'Verifikasi Recaptcha gagal.'
    }]}>
				<Input className={classes['captcha-field-box']} />
			</Form.Item>
			<Form.Item shouldUpdate>
				{props => {
        const {
          setFieldsValue,
          validateFields
        } = props;
        const onChangeCaptcha = (value: any) => {
          setFieldsValue({
            [name]: value
          });
        };
        return <ReCAPTCHA sitekey={`${sitekey}`} onChange={onChangeCaptcha} onExpired={() => {
          setFieldsValue({
            [name]: ''
          });
          validateFields();
        }} />;
      }}
			</Form.Item>
		</>;
};
export default CaptchaInput;